






















import { defineComponent, onMounted, reactive, ref } from '@vue/composition-api';
import axios, { Method } from 'axios';
import { ValidationObserver } from 'vee-validate';
import { formProps } from './formUtils';
import rules from './rules';
import OlbButton from '../button';
import OlbIcon from '../icon';

rules();

declare global {
	interface Window {
		recaptchaKey: string;
	}
}

declare let grecaptcha: any;

export default defineComponent({
	components: {
		ValidationObserver,
		OlbButton,
		OlbIcon,
	},
	props: {
		...formProps,
	},
	setup(props, { emit }) {
		const state = reactive({
			recaptchaLoading: false,
			res: {
				headline: '',
				text: '',
			},
			loading: false,
			error: '',
		});
		const observer = ref();
		const form = ref();

		function initRecaptcha() {
			state.recaptchaLoading = true;
			const recaptchaScript = document.createElement('script');
			recaptchaScript.setAttribute(
				'src',
				`https://www.google.com/recaptcha/api.js?render=${window.recaptchaKey}`,
			);
			document.head.appendChild(recaptchaScript);
		}
		function submitForm(token?: string) {
			const formData = new FormData(form.value);
			if (token) {
				formData.append('recaptcha', token);
			}
			axios({
				method: (props.method as Method) || 'GET',
				url: props.action,
				data: formData,
			})
				.then((data) => data.data)
				.then((res) => {
					state.res = res;
					state.loading = false;
				})
				.catch((error) => {
					state.error = error;
					state.loading = false;
				});
			emit('submit');
		}
		async function onSubmit(e: Event) {
			e.preventDefault();
			const isValid = await observer.value.validate();
			if (!isValid) {
				return;
			}
			state.loading = true;
			if (!props.action) {
				emit('submit');
				return;
			}
			if (!props.recaptcha) {
				submitForm();
				return;
			}
			if (typeof grecaptcha !== 'undefined') {
				try {
					grecaptcha.ready(() => {
						grecaptcha.execute(window.recaptchaKey).then(
							(token: string) => {
								submitForm(token);
							},
							(rejected: string) => {
								state.recaptchaLoading = false;
								console.log('Recaptcha request rejected', rejected);
								state.error = 'Recaptcha request rejected';
								state.loading = false;
							},
						);
					});
				} catch (error) {
					state.recaptchaLoading = false;
					console.log('Recaptcha failed', error);
					state.error = 'Recaptcha failed';
					state.loading = false;
				}
				return;
			}
			state.error = 'Recaptcha could not be loaded.';
		}

		function restartForm() {
			Object.assign(state, {
				recaptcha: '',
				res: {
					headline: '',
					text: '',
				},
				loading: false,
				error: '',
			});
			emit('reset-form');
		}
		onMounted(() => {
			(form.value as HTMLFormElement).addEventListener('focusin', () => {
				if (props.recaptcha && typeof grecaptcha === 'undefined') {
					initRecaptcha();
				}
			});
		});
		return {
			form,
			onSubmit,
			observer,
			state,
			restartForm,
		};
	},
});
